import React, { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { useHistory } from 'react-router';
import { useRouteMatch } from 'react-router-dom';
import SuccessScreen from '../../components/SuccessApplication';
import EfesContentHeader from '../../components/EfesContentHeader';
import Loader from '../../components/Loaders/Loader';
import WizardWrapper from '../../components/WizardWrapper';
import { LANGUAGES } from '../../constants';
import elementScroll from '../../helpers/elementScroll';
import useDeviceResize from '../../hooks/useDeviceResize';

import useStyles from './useStyles';

const CompensationContainer = ({
  claim,
  claimSteps,
  type,
  headerImage,
  headerText,
  clearForm,
  clearApplicantSearch,
  formLanguage,
  claimSuccessData,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const match = useRouteMatch();
  const classes = useStyles();
  const isDeviceLgSize = useDeviceResize('lg');
  const [currentStep, setCurrentStep] = useState(claimSteps[0]);
  const [unlockedSteps, setUnlockedSteps] = useState([claimSteps[0].id]);
  const [stepNavigationBox, setStepNavigationBox] = useState({});
  const countriesLoading = useSelector((store) => store.countriesReducer.countriesLoading);

  const scrollTo = useCallback((elem) => elementScroll(elem), []);
  const goToStep = useCallback((newStep) => history.push(`${match.url}/${newStep.id}`), [
    history,
    match.url,
  ]);

  const stepParams = {
    type,
    loader: <Loader />,
    hasLanguageSensitiveNames: true,
    setStepNavigationBox,
    formLanguage,
    scrollTo,
  };

  const startNew = useCallback(() => {
    dispatch(clearForm());
    dispatch(clearApplicantSearch());
    setCurrentStep(claimSteps[0]);
    setUnlockedSteps([claimSteps[0].id]);
  }, [claimSteps, clearApplicantSearch, clearForm, dispatch]);

  if (claim.submitSuccess) {
    return (
      <>
        <EfesContentHeader headerImage={headerImage} headerText={headerText} />
        <SuccessScreen startNewHandler={startNew} claimSuccessData={claimSuccessData} />
      </>
    );
  }

  return (
    <>
      {countriesLoading && <Loader />}
      <EfesContentHeader headerImage={headerImage} headerText={headerText} />
      <WizardWrapper
        steps={claimSteps}
        stepParams={stepParams}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        unlockedSteps={unlockedSteps}
        setUnlockedSteps={setUnlockedSteps}
        goToStep={goToStep}
      />
      <Grid
        container
        spacing={3}
        className={cn({
          [classes.mobileNavigation]: isDeviceLgSize,
        })}
      >
        <Grid item xs={12}>
          {!isEmpty(stepNavigationBox) && stepNavigationBox}
        </Grid>
      </Grid>
    </>
  );
};

CompensationContainer.propTypes = {
  claim: PropTypes.shape({
    submitSuccess: PropTypes.bool.isRequired,
    attachments: PropTypes.shape({
      files: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    language: PropTypes.string,
  }).isRequired,
  claimSteps: PropTypes.arrayOf(
    PropTypes.shape({
      n: PropTypes.number.isRequired,
      id: PropTypes.string.isRequired,
      icon: PropTypes.shape({}),
      label: PropTypes.string,
    }),
  ).isRequired,
  type: PropTypes.string.isRequired,
  headerImage: PropTypes.string.isRequired,
  headerText: PropTypes.string.isRequired,
  clearForm: PropTypes.func.isRequired,
  clearApplicantSearch: PropTypes.func.isRequired,
  formLanguage: PropTypes.string,
  claimSuccessData: PropTypes.arrayOf(PropTypes.shape({})),
};

CompensationContainer.defaultProps = {
  formLanguage: LANGUAGES.HY,
  claimSuccessData: undefined,
};

export default CompensationContainer;
